import Image from 'next/image'
import Link from 'next/link'
import styles from './ServicesRepeater.module.scss'

export default function ServicesRepeater(props) {
  const { subHeading, heading, darkBackground, hideDescription, services } = props.fields

  return (
    <>
      <div
        className={`${styles.servicesRepeaterSection} ${darkBackground === 'Yes' ? styles.darkBackground : ''}`}
        data-cy="services-section"
      >
        <div className={styles.servicesRepeaterSectionWrapper} data-aos="fade-up">
          {subHeading && (
            <p className={`${styles.servicesSubHeading} ${darkBackground === 'Yes' ? styles.whiteText : styles.darkText}`}>{subHeading}</p>
          )}
          <h3
            className={`${styles.servicesHeading} ${darkBackground === 'Yes' ? styles.whiteText : styles.darkText}`}
            data-cy="services-section-title"
          >
            {heading}
          </h3>

          <div className={styles.servicesRepeater}>
            {services.nodes.map((service) => {
              const imageNode =
                darkBackground === 'Yes'
                  ? service.serviceListingFields.serviceListingWhiteImage?.node
                  : service.serviceListingFields.serviceListingImage?.node

              const serviceUrl = service.serviceListingFields.servicePageLink?.url

              return (
                <div
                  key={service.id}
                  className={`${styles.service} ${serviceUrl ? styles.serviceLinked : ''}`}
                  style={{ alignItems: hideDescription === 'Yes' ? 'center' : 'flex-start' }}
                  data-cy="service-item"
                >
                  {imageNode?.sourceUrl && (
                    <div className={styles.image}>
                      <Image
                        src={imageNode.sourceUrl}
                        data-cy="service-item-image"
                        width={90}
                        height={90}
                        sizes="90px"
                        alt={imageNode.altText || ''}
                      />
                    </div>
                  )}
                  <div className={`${styles.contentRepeater} ${darkBackground === 'Yes' ? styles.whiteText : styles.darkText}`}>
                    <h4 data-cy="service-item-title">
                      {serviceUrl ? (
                        <Link href={serviceUrl} className={styles.serviceLink} data-cy-link="service-item-link">
                          {service.serviceListingFields.serviceListingName}
                        </Link>
                      ) : (
                        service.serviceListingFields.serviceListingName
                      )}
                    </h4>
                    {hideDescription === 'No' && (
                      <div
                        className={styles.servicesDescription}
                        data-cy="service-item-description"
                        dangerouslySetInnerHTML={{ __html: service.serviceListingFields.serviceListingDescription }}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
